import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { EicompService, EntityChangeEvent } from '@savvy/entity-instance-composite';
import { ChangeListener } from '../changeListener';
import { EventType } from '../../event/UiEvent';
import { EventBusService } from '../EventBusService';
import { ElementInstanceDto, FieldValueDto, IconsFieldDefinitionDto } from '@savvy/view-composite';
import { ContextIdDto } from '@savvy/datalist';


@Component({
    selector: 'app-icons-instance',
    templateUrl: './iconsInstance.component.html'
})
export class IconsInstanceComponent implements OnInit {

    @Input() iconsFieldDefinition: IconsFieldDefinitionDto;
    @Input() elementInstanceDto: ElementInstanceDto;
    @Input() entityInstanceId: string;
    @Input() contextIdDto: ContextIdDto;
    @Input() form: UntypedFormGroup;
    @Input() showPlaceholder: boolean;
    @Input() changeListener: ChangeListener;
    @Input() eventBus: EventBusService;

    constructor(private api: EicompService) {
    }

    get isValid() {

        if (this.form.controls[this.elementInstanceDto.instanceId] == null) {
            return false;
        } else {
            return this.form.controls[this.elementInstanceDto.instanceId].valid;
        }
    }

    ngOnInit(): void {

        if (this.form.controls[this.elementInstanceDto.instanceId] == null) {
            // console.log('PANIC missing form control for field name ' + this.fieldDefinition.name + ' id ' + this.fieldDefinition.id);
        } else {
            this.form.controls[this.elementInstanceDto.instanceId].valueChanges.pipe(debounceTime(400),
                distinctUntilChanged()).subscribe((value) =>  {
                    // console.log('changed value=' + value);
                    this.onChange(value);
                });
        }
    }

    getPlaceholder() {
        if (this.showPlaceholder) {
            return this.iconsFieldDefinition.label;
        }
        return '';
    }

    onChange(newValue: Array<string>) {
        const fieldValue: FieldValueDto = {
            strArrayValue: newValue,
            valueType: FieldValueDto.ValueTypeEnum.StringArray
        };
        const req: EntityChangeEvent = {
            contextIdDto: this.contextIdDto,
            fieldValue,
            entityInstanceId: this.entityInstanceId,
            fieldInstanceId: this.elementInstanceDto.instanceId
        };

        // There is no loadProductsResponse from this, do we care?
        this.api.entityInstanceChangeEvent(req).subscribe(
            response => {
                console.log('applied change to input instance, loadProductsResponse ' + response);
                console.log('changeListener is ' + this.changeListener);
                if (this.changeListener) {
                    this.changeListener.add('change');
                } else {
                    console.log('PANICK CHANGE LISTENER IS NULL IN INPUT INSTANCE');
                }
                this.eventBus.addCalendarEvent(EventType.REFRESH_CALENDAR);
            }
        );

    }
}

